import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CalendarClock } from "lucide-react";

// Vía comercial "que me lo monten": enlace externo de reserva (20 min), sin API ni iframe.
// variant="hero" (botón secundario + subtexto) | variant="link" (enlace discreto al pie).
export function OnboardingAsistido({ variant = "hero" }) {
  const [url, setUrl] = useState("");

  useEffect(() => {
    api.get("/onboarding/config").then(({ data }) => setUrl(data.url || "")).catch(() => setUrl(""));
  }, []);

  if (!url) return null;

  const abrir = () => {
    window.open(url, "_blank", "noopener");
    api.post("/onboarding/clic").catch(() => { /* el contador no debe bloquear la reserva */ });
  };

  if (variant === "link") {
    return (
      <button type="button" onClick={abrir} data-testid="onboarding-asistido-link"
        className="mt-4 text-sm text-[#0E2A47]/60 hover:text-[#FF5625] underline underline-offset-2 transition-colors">
        ¿Prefieres que lo hagamos contigo? Reserva 15 minutos
      </button>
    );
  }

  return (
    <div className="mt-4">
      <Button onClick={abrir} variant="outline" data-testid="onboarding-asistido-hero"
        className="bg-white/10 border-white/30 text-white hover:bg-white/20 font-semibold h-12 px-6">
        <CalendarClock size={18} className="mr-2" /> Prefiero que me lo monten
      </Button>
      <p className="mt-2 text-xs text-white/60 max-w-md">
        15 minutos. Compartimos pantalla y dejamos tu documentación dentro.
      </p>
    </div>
  );
}
